<template>
    <form-select
        label="Who Will Pay:"
        :value="value"
        :options="assigneeOptions"
        :error="error"
        @input="handleValueChange"
    ></form-select>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormSelect from '../../generic/form-select/form-select.vue';

    export default {
        name: 'RentalExpenseVendorSelect',
        components: {
            FormSelect,
        },
        props: {
            value: {
                type: Number,
                default: null,
            },
            error: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                assigneeOptions: [
                    { value: 0, text: 'Subscriber' },
                    { value: 1, text: 'Property Owner' },
                ],
            }
        },
        methods: {
            handleValueChange(value) {
                this.$emit('input', value);
            }
        }
    }
</script>
